<dsp-content-card [types]="[ 'select', 'datepicker' ]" [loading]="loading$ | async">


    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
        [id]="'tax-year-filter'" [label]="'Tax Year'" [placeholder]="'Pick One'" [(ngModel)]="year"
        (valueChange)="onChangeYear($event)" [disabled]="!((yearFilterOptions$ | async)?.length)"
        [options]="yearFilterOptions$ | async" [clearable]="false">
    </atlas-field-select>

    <atlas-field *dsp-content-filter [widthValue]="270" [size]="sizeMedium">
        <atlas-field-label>As At</atlas-field-label>
        <input [(ngModel)]="asAt" atlasInput [min]="minDate$ | async" [max]="maxDate$ | async" [Datepicker]="pickerAsAt"
            placeholder="Day Month Year" (ngModelChange)="onChangeAsAt($event)" [readonly]="true" />
        <atlas-field-suffix>
            <datepicker-toggle [datepicker]="pickerAsAt"></datepicker-toggle>
        </atlas-field-suffix>
        <datepicker #pickerAsAt> </datepicker>
    </atlas-field>
    <div dsp-content>
        <div class="row">
            <div class="columns">
                <p *ngIf="message" class="alert"
                    [ngClass]="(showTaxDetailsData$ | async) ? 'green-tax-details-msg' : 'red-tax-details-msg'">
                    {{message}}
                </p>
                <div class="dsp-title-container">
                    <atlas-icon [icon]="'icon-webpage-24'" [size]="'large'" [color]="'primary'" [alt]="'Tax-Details'">

                    </atlas-icon>
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
                        <!-- Gross PIE Tax Information -->
                        Prescribed Investor Rate (PIR)
                    </h3>
                    <atlas-icon class="mos-u-spacer--margin-left-xxsm" [haloTooltipWithArrow]="true"
                        [haloTooltip]="'A Prescribed Investor Rate (PIR) is the tax rate that a Portfolio Investment Entity (PIE) uses to work out the tax on investment income. Every client holds their own Prescribed Investor Rate (PIR) as a percentage.'"
                        [haloTooltipPosition]="'right'" [haloTooltipShowDelay]="100" [id]="'tax-details-note-icon'"
                        size="small" [icon]="'c-info'" [collection]="'user-interface'" [alt]="'info'">
                    </atlas-icon>
                </div>
                <div *ngIf="data$ | async" class="row mos-u-spacer--margin-bottom-md">
                    <div class="columns">
                        <p [id]="'tax-details-as-at-date'" class="dsp-date mos-u-spacer--margin-none dsp-subtitle">
                            as at {{ asAtViewDate$ | async }}
                        </p>
                    </div>
                </div>
                <div class="mos-c-multi-select__toggle__container">
                    <span>{{ (pirValue$ | async) }}</span>
                </div>
            </div>
        </div>
        <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
            <span class="dsp-terms-and-conditions-applied">
                *If you need to update your Prescribed Investor Rate (PIR), please contact us
            </span>
        </div>
        <div class="row">
            <div class="columns">
                <div class="dsp-title-container">
                    <atlas-icon icon="coins" collection="business-finance-solid" size="large" color="primary"
                        [alt]="'Tax Details'">
                    </atlas-icon>
                    <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
                        PIE Tax Information
                    </h3>
                    <atlas-icon class="mos-u-spacer--margin-left-xxsm" [haloTooltipWithArrow]="true"
                        [haloTooltip]="(notes$ | async)?.taxDetails" [haloTooltipPosition]="'right'"
                        [haloTooltipShowDelay]="100" [id]="'tax-details-note-icon'" size="small" [icon]="'c-info'"
                        [collection]="'user-interface'" [alt]="'info'">
                    </atlas-icon>


                    <div class="columns shrink" [style.margin-left]="'auto'" *ngIf="(data$ | async)?.length > 0">
                        <atlas-dropdown #taxDetailsDropdown="atlasDropdown" [id]="'toggle-tax-details-export'"
                            [icon]="'more_vert'" [iconSize]="sizeMedium" [placement]="dropdownPlacementLeftStart"
                            [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
                            [triggerType]="dropdownTriggerTypeIconButton">
                            <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
                                <atlas-menu-item (click)="taxDetailsDropdown.menu?.closeMenu($event); onExportPDF()">
                                    <a [id]="'ListViewLabel'">
                                        Export as PDF
                                    </a>
                                </atlas-menu-item>
                                <atlas-menu-item (click)="taxDetailsDropdown.menu?.closeMenu($event); onExportCSV()">
                                    <a [id]="'ChartViewLabel'">
                                        Export as CSV
                                    </a>
                                </atlas-menu-item>
                            </atlas-menu>
                        </atlas-dropdown>
                    </div>
                </div>
                <div *ngIf="data$ | async" class="row mos-u-spacer--margin-bottom-md">
                    <div class="columns">
                        <p [id]="'tax-details-as-at-date'" class="dsp-date mos-u-spacer--margin-none dsp-subtitle">
                            as at {{ asAtViewDate$ | async }}
                        </p>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="(data$ | async)?.length" class="mos-u-spacer--padding-bottom-xlg">
            <div class="dsp-table-scroll-wrapper">
                <atlas-table (onSort)="onSort($event)">
                    <thead atlas-table-header #header>

                        <tr atlas-table-row>
                            <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col">
                                {{ col.displayLabel }}
                            </th>
                        </tr>
                    </thead>
                    <tbody atlas-table-body>
                        <tr halo-table-row *ngFor="let row of data$ | async | sort:header.sortOption">

                            <td atlas-table-cell>

                                {{ row.fundName }}


                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.taxableIncomeYTD && row.taxableIncomeYTD !== 0 ? (row.taxableIncomeYTD | decimal)
                                :
                                '-'
                                }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.managementFeeRebateYTD && row.managementFeeRebateYTD !== 0 ?
                                (row.managementFeeRebateYTD
                                | decimal) : '-' }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.totalTaxIncome && row.totalTaxIncome !== 0 ? (row.totalTaxIncome | decimal) : '-'
                                }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.foreignTaxCreditYTD && row.foreignTaxCreditYTD !== 0 ? (row.foreignTaxCreditYTD |
                                decimal) : '-' }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.fdwpCreditYTD && row.fdwpCreditYTD !== 0 ? (row.fdwpCreditYTD | decimal) : '-' }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.rwtCreditYTD && row.rwtCreditYTD !== 0 ? (row.rwtCreditYTD | decimal) : '-' }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.imputationCreditYTD && row.imputationCreditYTD !== 0 ? (row.imputationCreditYTD |
                                decimal) : '-' }}
                            </td>
                            <!-- <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                        {{ row.taxToPayCredit && row.taxToPayCredit !== 0 ? (row.taxToPayCredit |
                        decimal) : '-' }}
                    </td>
                    <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                        {{ row.taxPaid && row.taxPaid !== 0 ? (row.taxPaid |
                        decimal) : '-' }}
                    </td> -->
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
                                {{ row.netTaxLiability && row.netTaxLiability !== 0 ? (row.netTaxLiability |
                                decimal) : '-' }}
                            </td>

                        </tr>
                    </tbody>
                    <tfoot atlas-table-footer>
                        <tr atlas-table-row>
                            <td atlas-table-cell class="dsp-tax-detail-total">
                                {{total.fundName}}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.taxableIncomeYTD && total.taxableIncomeYTD !== 0 ? (total.taxableIncomeYTD |
                                decimal) : '-'
                                }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.managementFeeRebateYTD && total.managementFeeRebateYTD !== 0 ?
                                (total.managementFeeRebateYTD
                                | decimal) : '-' }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.totalTaxIncome && total.totalTaxIncome !== 0 ? (total.totalTaxIncome | decimal)
                                :
                                '-' }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.foreignTaxCreditYTD && total.foreignTaxCreditYTD !== 0 ?
                                (total.foreignTaxCreditYTD
                                |
                                decimal) : '-' }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.fdwpCreditYTD && total.fdwpCreditYTD !== 0 ? (total.fdwpCreditYTD | decimal) :
                                '-'
                                }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.rwtCreditYTD && total.rwtCreditYTD !== 0 ? (total.rwtCreditYTD | decimal) : '-'
                                }}
                            </td>
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.imputationCreditYTD && total.imputationCreditYTD !== 0 ?
                                (total.imputationCreditYTD
                                |
                                decimal) : '-' }}
                            </td>
                            <!-- <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                            {{ total.taxToPayCredit && total.taxToPayCredit !== 0 ? (total.taxToPayCredit |
                            decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                            {{ total.taxPaid && total.taxPaid !== 0 ? (total.taxPaid |
                            decimal) : '-' }}
                        </td> -->
                            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font dsp-tax-detail-total">
                                {{ total.netTaxLiability && total.netTaxLiability !== 0 ? (total.netTaxLiability |
                                decimal) : '-' }}
                            </td>
                        </tr>
                    </tfoot>
                </atlas-table>
            </div><!-- /.dsp-table-scroll-wrapper -->
            <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
                <span class="dsp-terms-and-conditions-applied">
                    <!-- *Please note that any negative values are a rebate -->
                    *The PIE Tax Information detail the taxable income and the relevant components allocated to you
                    during the PIE tax year to date
                </span>
                <br />
                <span class="dsp-terms-and-conditions-applied">
                    **Please note that any negative values are a rebate for the Tax Liability / Rebate ($) column
                </span>
            </div>
        </div>
        <div *ngIf="!((data$ | async)?.length > 0)" class="mos-u-align-center--both no-data" [style.height.px]="100">
            <h3>No data for selected date.</h3>
        </div>
    </div>



</dsp-content-card>